import { render, staticRenderFns } from "./en-AB.vue?vue&type=template&id=745a4934&"
import script from "./en-AB.vue?vue&type=script&lang=js&"
export * from "./en-AB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745a4934')) {
      api.createRecord('745a4934', component.options)
    } else {
      api.reload('745a4934', component.options)
    }
    module.hot.accept("./en-AB.vue?vue&type=template&id=745a4934&", function () {
      api.rerender('745a4934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/en-AB.vue"
export default component.exports